import { render } from "./PanelView.vue?vue&type=template&id=6e488aa8&ts=true"
import script from "./PanelView.vue?vue&type=script&lang=ts"
export * from "./PanelView.vue?vue&type=script&lang=ts"

import "./PanelView.vue?vue&type=style&index=0&id=6e488aa8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__